import styled from '@emotion/styled';
import { FormError } from 'ui/components/elements/FormError/FormError';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    overflow-y: auto;
`;

const Desc = styled.p`
    margin-block: 12px 20px;
    padding: 0 4px;
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const TextArea = styled.textarea`
    width: 100%;
    height: 100px;
    padding: 8px;
    border: 2px solid #a9a9a9;
    border-radius: 4px;
    font-size: var(--font-normal);
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    margin: 10px auto 0 auto;
    border: none;
    outline: none;
`;

const ErrorMsgContainer = styled.div`
    margin-right: auto;
`;

interface Props {
    setValue: (value: string) => void;
    onClick: () => void;
    errorMsg: string;
    loading: boolean;
}

/**
 * オファーお断り理由記入モーダル
 */
export const DeclineMeetingRequest: React.FC<Props> = ({ setValue, onClick, errorMsg, loading }) => {
    return (
        <Wrapper>
            <Descriptions>
                <Desc>※オファーをお断りします。よろしいですか？</Desc>
            </Descriptions>
            <TextArea
                maxLength={1000}
                placeholder="お断り理由をご記入お願いします。"
                onChange={(e) => setValue(e.target.value)}
            />
            <ErrorMsgContainer>{errorMsg && <FormError message={errorMsg} />}</ErrorMsgContainer>

            <SubmitButton disabled={loading} onClick={onClick}>
                お断りする
            </SubmitButton>
        </Wrapper>
    );
};
